// extracted by mini-css-extract-plugin
export var container = "_2d-0";
export var disabled = "_2d-4";
export var fullWidth = "_2d-3";
export var lined = "_2d-1";
export var selected = "_2d-5";
export var tab = "_2d-2";